import { CircleSlash, X } from "lucide-react";

interface Props {
  onDismiss: () => void;
}

export function QuotaBanner({ onDismiss }: Props) {
  return (
    <div className="bg-danger/8 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2.5">
          <CircleSlash
            className="mt-0.5 shrink-0 text-danger"
            size={18}
            fill="currentColor"
            stroke="white"
            strokeWidth={2}
          />
          <div className="space-y-2">
            <p className="text-[1rem] font-bold text-danger">Quota reached</p>
            <p className="text-sm text-neutral-700">
              Your organisation has reached its usage limit. Contact your
              administrator to continue using the assistant.
            </p>
            <p className="text-sm font-bold text-neutral-900">View billing</p>
          </div>
        </div>
        <button
          onClick={onDismiss}
          className="shrink-0 text-ink hover:text-neutral-600"
          aria-label="Dismiss quota banner"
        >
          <X size={22} />
        </button>
      </div>
    </div>
  );
}
